import { render, staticRenderFns } from "./StatusClienteSelect.vue?vue&type=template&id=0af1c1ea&"
import script from "./StatusClienteSelect.vue?vue&type=script&lang=js&"
export * from "./StatusClienteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports